import { Modal, Spinner } from "react-bootstrap";
import moment from "moment-jalaali";
import { get, post } from "../../../controlers/global/ConfigRequest";
import {
    CLUB_SEND_OTP,
    CLUB_VERIFY_OTP,
    GET_SHARE_LINK,
} from "../../../helperData/ApiAddress";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GlobalStateContext } from "../../../layouts/GlobalStates";
import { applyTokenResponse } from "../../../helperData/panelRoutes";
import FidimaBrand from "./FidimaBrand";
// export default function ClubAuthModal({ show, verified }) {

// const { id } = useParams();

// moment.loadPersian();
moment.loadPersian();

const AUTO_SHARE_MARKERS = [
    "برای شما ارسال شده است",
    "برای شما به اشتراک گذاشته شده است",
    "was shared with you",
];

function customShareMessage(description) {
    const text = (description || "").trim();
    if (!text) return "";
    if (AUTO_SHARE_MARKERS.some((marker) => text.includes(marker))) {
        return "";
    }
    return text;
}

export default function ClubAuthModal({ show, onHide, verified }) {
    const { id } = useParams();
    const { setAuth } = useContext(GlobalStateContext);
    const [loader, setLoader] = useState(true);
    const [sendOTPLoader, setSendOTPLoader] = useState(false);
    const [verifyLoader, setVerifyLoader] = useState(false);
    const [page, setPage] = useState(1);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [phoneNumberErr, setPhoneNumberErr] = useState("");
    const [code, setCode] = useState("");
    const [codeErr, setCodeErr] = useState("");
    const [debugCode, setDebugCode] = useState("");
    const [otpTimer, setOtpTimer] = useState(0);
    const [content, setContent] = useState();
    const { t } = useTranslation();

    const phoneValidator = (phone) => {
        if (!phone) {
            return false;
        }

        const whiteList = /^\+?([0-9]*)$/;
        if (!whiteList.test(phone)) {
            return t(
                "Src.Component.Global.AuthModal.ChangePassword.setPhoneErr"
            );
        }
        if (phone[0] !== "+")
            if (phone.length !== 11 || phone[0] !== "0" || phone[1] !== "9") {
                return t(
                    "Src.Component.Global.AuthModal.ChangePassword.setPhoneErr"
                );
            }
        return true;
    };

    const sendOtpHandle = () => {
        setPhoneNumberErr("");
        if (phoneValidator(phoneNumber) === true) {
            sendPhoneNumber();
        } else {
            setPhoneNumberErr(phoneValidator(phoneNumber));
        }
    };
    //   if (phone[0] !== '+')
    //     if (phone.length !== 11 || phone[0] !== "0" || phone[1] !== "9") {
    //       return (t('Src.Component.Global.AuthModal.ChangePassword.setPhoneErr'));
    //     }
    //   return true;
    // }

    const sendPhoneNumber = () => {
        setSendOTPLoader(true);
        let phone_number = "+98" + phoneNumber.substr(1);
        post(CLUB_SEND_OTP.replace(":id", id), {
            phone_number,
        })
            .then((response) => {
                setPage(2);
                setCode("");
                setCodeErr("");
                setDebugCode(response?.otp_debug_code || "");
                setOtpTimer(120);
            })
            .catch(() => {
                setPhoneNumberErr(
                    t(
                        "Src.Pages.UserPages.CustomerrClub.ClubAuthModal.setCodeErr"
                    )
                );
            })
            .finally(() => {
                setSendOTPLoader(false);
            });
    };

    const verifyCodeHandle = () => {
        setVerifyLoader(true);
        let phone_number = "+98" + phoneNumber.substr(1);
        post(CLUB_VERIFY_OTP.replace(":id", id), {
            phone_number,
            otp_code: code,
        })
            .then((response) => {
                try {
                    applyTokenResponse(setAuth, response);
                } catch (error) {
                    // Content access still continues if token persistence fails.
                }
                verified(response.link || response);
            })
            .catch(() => {
                setCodeErr("کد وارد شده صحیح نمی‌باشد");
            })
            .finally(() => {
                setVerifyLoader(false);
            });
    };
    // }, [otpTimer]);

    const userMessage = customShareMessage(content?.description);
    const itemName =
        content?.content_name || content?.item_name || "";
    const userNumber = content?.user_number || "";
    const introReady = Boolean(userNumber && itemName);
    const introKey = userMessage
        ? "Src.Pages.UserPages.CustomerrClub.ClubAuthModal.Intro.WithMessage"
        : "Src.Pages.UserPages.CustomerrClub.ClubAuthModal.Intro";

    useEffect(() => {
        if (otpTimer > 0) {
            setTimeout((_) => setOtpTimer(otpTimer - 1), 1000);
        }
    }, [otpTimer]);

    useEffect(() => {
        get(GET_SHARE_LINK.replace(":id", id)).then((r) => {
            setContent(r);
        });
    }, []);

    return (
        <Modal
            animation={false}
            show={show}
            centered={true}
            fullscreen="sm-down"
            className="club-auth-modal"
        >
            <Modal.Body>
                {!loader ? (
                    <div className="loader-container">
                        <Spinner animation="border" />
                    </div>
                ) : (
                    <>
                        <div className="club-auth-modal__inner">
                            <FidimaBrand />
                            {page === 1 && (
                            <div>
                                {introReady ? (
                                    <>
                                        <p className="share-intro">
                                            {t(introKey, {
                                                user: `\u200E${userNumber}`,
                                                item: itemName,
                                            })}
                                        </p>
                                        <p className="share-thanks">
                                            {t(
                                                "Src.Pages.UserPages.CustomerrClub.ClubAuthModal.Thanks"
                                            )}
                                        </p>
                                    </>
                                ) : (
                                    <p className="share-intro">
                                        {t(
                                            "Src.Pages.UserPages.CustomerrClub.ClubAuthModal.Loading.Label"
                                        )}
                                    </p>
                                )}
                                {userMessage ? (
                                    <div className="user-message">
                                        <h3>
                                            {t(
                                                "Src.Pages.UserPages.CustomerrClub.ClubAuthModal.UserMessage.Label"
                                            )}
                                        </h3>
                                        <blockquote>{userMessage}</blockquote>
                                    </div>
                                ) : null}
                                <h6>
                                    {t(
                                        "Src.Pages.UserPages.CustomerrClub.ClubAuthModal.AddNumber.Label"
                                    )}
                                </h6>
                                <div className="club-auth-modal__field">
                                    <label htmlFor="club-share-phone" className="sr-only">
                                        شماره موبایل
                                    </label>
                                    <input
                                        id="club-share-phone"
                                        type="tel"
                                        inputMode="numeric"
                                        autoComplete="tel"
                                        onChange={(e) =>
                                            setPhoneNumber(e.target.value)
                                        }
                                        value={phoneNumber}
                                        className={
                                            "club-auth-modal__phone" +
                                            (phoneNumberErr ? " err" : "")
                                        }
                                        onClick={() => setPhoneNumberErr("")}
                                    />
                                    {phoneNumberErr && (
                                        <div className="err-msg">
                                            {phoneNumberErr}
                                        </div>
                                    )}
                                </div>
                                <div className="club-auth-modal__actions">
                                    <button
                                        className="primary-button"
                                        onClick={sendOtpHandle}
                                        disabled={phoneNumber === ""}
                                    >
                                        {sendOTPLoader ? (
                                            <Spinner animation="border" />
                                        ) : (
                                            <span>ادامه</span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        )}
                        {page === 2 && (
                            <div>
                                <p>
                                    {t(
                                        "Src.Pages.UserPages.CustomerrClub.ClubAuthModal.EnterOTP.Label"
                                    )}
                                </p>
                                {debugCode && (
                                    <div className="share-otp-debug" role="status">
                                        <span>کد محیط توسعه</span>
                                        <strong dir="ltr">{debugCode}</strong>
                                    </div>
                                )}
                                <div className="input-repeat-con">
                                    <label htmlFor="club-share-otp" className="sr-only">
                                        کد تایید
                                    </label>
                                    <input
                                        id="club-share-otp"
                                        type="tel"
                                        inputMode="numeric"
                                        autoComplete="one-time-code"
                                        onChange={(e) =>
                                            setCode(e.target.value)
                                        }
                                        value={code}
                                        className={
                                            "club-auth-modal__otp" +
                                            (codeErr ? " err" : "")
                                        }
                                    />

                                    <button
                                        disabled={otpTimer > 0}
                                        onClick={sendPhoneNumber}
                                        className="repeat-button"
                                    >
                                        {sendOTPLoader ? (
                                            <Spinner animation="border" />
                                        ) : otpTimer ? (
                                            otpTimer
                                        ) : (
                                            <span>ارسال مجدد</span>
                                        )}
                                    </button>
                                </div>
                                {codeErr && (
                                    <div
                                        className="err-msg"
                                        style={{ textAlign: "right" }}
                                    >
                                        {codeErr}
                                    </div>
                                )}
                                <div className="club-auth-modal__actions">
                                    <button
                                        className="primary-button"
                                        onClick={verifyCodeHandle}
                                        disabled={code === ""}
                                    >
                                        {verifyLoader ? (
                                            <Spinner animation="border" />
                                        ) : (
                                            <span>مشاهده محتوا</span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        )}
                        </div>
                    </>
                )}
            </Modal.Body>
        </Modal>
    );
}
